export default __webpack_public_path__ + "static/media/IMG_5582.59f3e17a.jpg";